type YTPlayerOpts = {
  events?: {
    onReady?: () => void;
    onStateChange?: (e: { data: number }) => void;
  };
};

export type YTPlayer = {
  getCurrentTime: () => number;
  getDuration: () => number;
  getPlayerState: () => number;
  playVideo: () => void;
  pauseVideo: () => void;
  seekTo: (seconds: number, allowSeekAhead: boolean) => void;
  destroy: () => void;
};

// YouTube IFrame API state codes
export const YT_STATE = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5,
} as const;

type YT = {
  Player: new (el: HTMLElement | string, opts: YTPlayerOpts) => YTPlayer;
};

declare global {
  interface Window {
    YT?: YT;
    onYouTubeIframeAPIReady?: () => void;
  }
}

let apiPromise: Promise<void> | null = null;

function injectScript(): void {
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(tag);
}

export function loadYouTubeAPI(): Promise<void> {
  if (apiPromise) return apiPromise;
  if (window.YT?.Player) {
    apiPromise = Promise.resolve();
    return apiPromise;
  }
  apiPromise = new Promise<void>((resolve) => {
    const prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = (): void => {
      prev?.();
      resolve();
    };
    injectScript();
  });
  return apiPromise;
}

export function getYT(): YT | null {
  return window.YT ?? null;
}
